import styled from "styled-components";

export const Container = styled.div`
  background: #44403d;
`;
